import React from "react";
import { Dispatch, SetStateAction } from "react";
import Typography from "../Typography/Typography";
import { IFilters } from "../IndividualStudentsStatisticsList/IndividualStudentsStatisticsList";

interface FiltersComponentProps {
  filtersCount: IFilters;
  setFiltersCount: Dispatch<SetStateAction<IFilters>>;
  filterOptions: { value: string; label: string }[];
  onSearch?: () => void;
  clearFilter?: () => void;
}

export const FiltersComponent: React.FC<FiltersComponentProps> = ({
  filtersCount,
  setFiltersCount,
  filterOptions,
  onSearch,
  clearFilter,
}) => {
  const addFilter = () => {
    const newFilter = filterOptions.find(
      (option) => !Object.keys(filtersCount).includes(option.value)
    );
    if (newFilter) {
      setFiltersCount((prevFilters) => ({
        ...prevFilters,
        [newFilter.value]: "",
      }));
    }
  };

  return (
    <div className="flex gap-24 max-lg:gap-16 flex-wrap mt-24 max-lg:mt-8">
      <button
        onClick={addFilter}
        className="rounded-2xl border border-secondary px-12 py-[8px] cursor-pointer hover:bg-[#F5F5FC]"
      >
        <Typography type="Body2" typeSM="Body3" className="!font-normal">
          Add filter
        </Typography>
      </button>
      <div className="flex flex-wrap gap-10">
        {Object.keys(filtersCount).map((filter: string, index: number) => {
          const value = filtersCount[filter as keyof IFilters];
          const availableOptions = filterOptions.filter(
            (option) =>
              option.value === filter ||
              !Object.keys(filtersCount).includes(option.value)
          );
          return (
            <div key={index} className="flex gap-8">
              <select
                value={
                  filterOptions.find((option) => option.value === filter)?.value
                }
                onChange={(e) => {
                  if (e.target.value) {
                    setFiltersCount((prevFilters) => {
                      const newFilters = { ...prevFilters };
                      const currentValue =
                        prevFilters[filter as keyof IFilters] || "";
                      delete newFilters[filter as keyof IFilters];
                      newFilters[e.target.value as keyof IFilters] =
                        currentValue;
                      return newFilters;
                    });
                  }
                }}
                className="max-lg:text-[12px] custom-select rounded-2xl border border-secondary px-12 pr-36 py-[8px] cursor-pointer appearance-none focus:outline-none hover:bg-[#F5F5FC]"
              >
                {availableOptions.map((option) => (
                  <option value={option.value} key={option.value}>
                    <Typography type="Body2" typeSM="Body3">
                      {option.label}
                    </Typography>
                  </option>
                ))}
              </select>

              <input
                type="text"
                className="rounded-2xl border max-lg:text-[12px] border-secondary px-12 py-[8px] focus:outline-none"
                placeholder="Containing"
                onChange={(e) => {
                  const newFilters = {
                    ...filtersCount,
                    [filter]: e.target.value,
                  };
                  setFiltersCount(newFilters);
                }}
                value={value as string}
              />
            </div>
          );
        })}
      </div>

      {Object.keys(filtersCount).length > 0 && (
        <>
          <button
            onClick={onSearch}
            className="rounded-2xl bg-primary px-24 py-[8px] cursor-pointer hover:bg-hover"
          >
            <Typography type="Body2" typeSM="Body3" className="text-white">
              Search
            </Typography>
          </button>

          <button
            onClick={clearFilter}
            className="rounded-2xl border border-secondary px-12 py-[8px] cursor-pointer hover:bg-[#F5F5FC]"
          >
            <Typography type="Body2" typeSM="Body3" className="text-primary">
              Clear filter
            </Typography>
          </button>
        </>
      )}
    </div>
  );
};
